import { Injectable } from '@angular/core';
import { ApiConnectorService } from '../__api/api-connector.service';
import { BookingService } from '../booking.service';
import { EventEmitterService } from './event-emitter.service';
import { FunctionsService } from './functions.service';

@Injectable({
  providedIn: 'root'
})
export class ResolverService {

  loadingObj = {};
  cache = {};
  empty = {};

  cache2 = [
    {
      products: []
    },
    {
      products: []
    },
    {
      products: []
    }
  ];

  constructor(private apiConnector: ApiConnectorService,private eventEmitterService: EventEmitterService,private bookingService: BookingService,private commonFunctions: FunctionsService) {
    // RESOLVER GETTING RESULT OBJECT
    if (this.eventEmitterService.subsVar==undefined) {    
      this.eventEmitterService.subsVar = this.eventEmitterService.    
      invokeFirstComponentFunction.subscribe((data:any) => {
        this.saveDataToLocalCache(data.cacheLabel,data.obj);
      });

      this.eventEmitterService.subsVar = this.eventEmitterService.
      invokeLoginAttemptFunction.subscribe((isValid:any) => {
        this.saveAnswerToValidationAttempt(isValid);
      });

      this.eventEmitterService.subsVar = this.eventEmitterService.
      invokeGetPackagesAssociated.subscribe((data:any) => {
        this.getProductsPerPack(data.records[0].data);
      });


    }else{
      debugger;
      /* this.clientApps = this.resolver.getClientApps().records; */
    }
  }

  getProductsPerPack(packageObjList){
    for(let pack of JSON.parse(packageObjList)){
      this.getPackDetails(pack.id,pack.package_type)
    }
  }

  getCachePacks(){
    return this.cache2;
  }

  getPackDetails(idPack,label){
    this.apiConnector.simpleQueryId('getPackDetails',idPack,null,null,null,null).subscribe(
      (response) => {
        this.savePackDetails(response,label);
      },
      (error) => {
        debugger
        /* this.guiFlow.reportError(error,'onboarding-page'); */
      }
    );
  }


  savePackDetails(products,label){
    for(let product of products.records){
      switch(product.package_type){
        case 'basic':
          this.cache2[0]['products'] = this.commonFunctions.addProduct(product.product,this.cache2[0]['products']);
          break;
        case 'premium':
          this.cache2[1]['products'] = this.commonFunctions.addProduct(product.product,this.cache2[1]['products']);
          break;
        case 'full':
          this.cache2[2]['products'] = this.commonFunctions.addProduct(product.product,this.cache2[2]['products']);
          break;
        default:
          break;
      }
    }
  }

  getResource(queryId,id,force){ 
    this.loadingObj[queryId] = true;
    if(!force && this.cache[queryId]){
      this.loadingObj[queryId] = false;
      return this.cache[queryId];
    }else{
      this.apiConnector.simpleQueryId(queryId,id,null,null,null,null)
      .subscribe(
        (response) => {
            this.cache[queryId] = response;
            // Use event emmiter
            this.eventEmitterService.onDependecyResolved(response,queryId);
            this.loadingObj[queryId] = false;
            },
        (error) => {
          this.loadingObj[queryId] = false;
          }
        );
    }
  }

  getDependency(cacheLabel){
    if(this.cache[cacheLabel]){
      return this.cache[cacheLabel];
    }else{
      return this.empty[cacheLabel];
    }
  }

  isLoading(cacheLabel){
    return this.loadingObj[cacheLabel];
  }

  // DEPENDENCY RESOLVED
  saveDataToLocalCache(cacheLabel,data){
    this.cache[cacheLabel] = data;
  }

  tryToValidate(password){
    this.apiConnector.tryToValidate(password);
  }

  saveAnswerToValidationAttempt(value){
    this.cache['validated'] = value;
    this.loadingObj['validated'] = false;
    value? this.getResource('getCotizacion',this.bookingService.getToken(),true) : null;
  }

  setIsLoading(cacheLabel,value){
    this.loadingObj[cacheLabel] = value;
  }
  
}
